import { composer } from '../../component-decorators/composer';
import { MenuSection } from './menu-section';
import { HomeMenuItem } from '../menu-item';
import { Path } from '../../enums/marketplace-enums';
import * as React from 'react';
export var MenuSections = composer()
    .withMarketplaceStore()
    .compose(function (_a) {
    var sections = _a.sections, marketplaceStore = _a.marketplaceStore;
    var sectionsSizes = [];
    sections === null || sections === void 0 ? void 0 : sections.map(function (_a, index) {
        var _b, _c, _d, _e;
        var sectionData = _a.sectionData;
        sectionsSizes[index] =
            index === 0
                ? (_c = (_b = sectionData === null || sectionData === void 0 ? void 0 : sectionData.tagData) === null || _b === void 0 ? void 0 : _b.tagsToWebSolutions) === null || _c === void 0 ? void 0 : _c.length : ((_e = (_d = sectionData === null || sectionData === void 0 ? void 0 : sectionData.tagData) === null || _d === void 0 ? void 0 : _d.tagsToWebSolutions) === null || _e === void 0 ? void 0 : _e.length) +
                sectionsSizes[index - 1];
    });
    var getMenuIndex = function (index) { return (index === 0 ? 0 : sectionsSizes[index - 1]); };
    var isHomeSelected = marketplaceStore.route.path === Path.HOME;
    return (React.createElement(React.Fragment, null,
        React.createElement(HomeMenuItem, { isSelected: isHomeSelected }), sections === null || sections === void 0 ? void 0 :
        sections.map(function (_a, index) {
            var id = _a.id, type = _a.type, sectionData = _a.sectionData;
            return (React.createElement(MenuSection, { key: id, id: id, type: type, sectionData: sectionData, menuIndex: getMenuIndex(index) }));
        })));
});
//# sourceMappingURL=menu-sections.js.map